module.exports = __webpack_public_path__ + "img/perforaciones_3-4_768.50c7e72f.webp";